import { Observable } from 'rxjs';

import { Document } from 'document/document';

export abstract class DocumentRepositoryPort {
	public abstract observeDocuments(
		documentsId: string[]
	): Observable<Document[]>;

	public abstract saveDocuments(documents: Document[]): void;

	public abstract observeDocument(documentId: string): Observable<Document>;
}
